import { GET, PATCH, POST, DELETE } from "../../helper/xbi4RestFunctions";
export const getPeopleLeadCommentByPlead = async (org_id: any, org_user_id: any,project_id:any) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/project/${project_id}`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};